// Import react.
import * as React from 'react';
// Import interfaces.
import {
	ILogoutInfo,
	IUserData,
} from '@app/interfaces';
// Import types.
import {
	TSessionTimeListenerCallback,
} from '@app/types';

interface IAuthenticationContext {
	userData: IUserData;
	login: () => Promise<void>;
	logout: (loginInfo: ILogoutInfo) => Promise<void>;
	handleLogoutRequest: (redirectToCurrentUrl: boolean) => Promise<void>;
	handleLogoutRequestWithUrl: (url: string) => Promise<void>;
	refreshToken: (onFinishCallback?: () => void) => Promise<void>;
	registerSessionTimeListener: (sessionTimeListener: TSessionTimeListenerCallback) => void;
}

const AuthenticationContext: React.Context<IAuthenticationContext> = React.createContext<IAuthenticationContext>({
	userData: {
		userId: -1,
		username: String.empty(),
		userFullName: String.empty(),
		impersonatorUserFullName: String.empty(),
		userGroupsAsListString: String.empty(),
		isUserDataLoaded: false,
		isUserAdmin: false,
		isUserUnderwriter: false,
		isUserProducerAdmin: false,
		isUserNPBEAdmin: false,
		isUserLoggedIn: false,
		externalAmsId: undefined,
		externalAmsName: undefined,
		externalAmsSystemLoginUrl: undefined,
		isExternalAmsUser: false,
	},
	login: async () => { },
	logout: async (loginInfo: ILogoutInfo) => { },
	handleLogoutRequest: async (redirectToCurrentUrl: boolean) => { },
	handleLogoutRequestWithUrl: async (url: string) => { },
	refreshToken: async () => { },
	registerSessionTimeListener: (sessionTimeListener: TSessionTimeListenerCallback) => { },
});

export default AuthenticationContext;